import object from '@mailobj-browser/front/js/utils/object.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import keyDown from '@mailobj-browser/front/js/events/types/keyDown.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import meta from '#utilities/js/ea/meta.js'
import { helpers } from '../styles.js'
import * as selectorSet from '../date/selector/tools.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const { isInteger, parseInt } = Number

const patterns = object(null, {
  'DMY': /^(\d{2})?(?:[\/\.-](\d{2}))?(?:[\/\.-](\d{4}))?$/,
  'MDY': /^(\d{2})?(?:[\/\.-](\d{2}))?(?:[\/\.-](\d{4}))?$/,
  'YMD': /^(\d{4})?(?:[\/\.-](\d{2}))?(?:[\/\.-](\d{2}))?$/
})

const keys = array([
  '/',
  'Delete',
  'Backspace'
])

const addSlashes = (match, first, second, third) =>
  [first, first && '/', second, second && '/', third]
    .filter(Boolean)
    .join('')

const wmInput = new WeakSet()

const onKeyDown = object(listener, {
  type: keyDown,
  passive,
  task: (input, { key }) => {
    if (!keys.includes(key)) {
      wmInput.add(input)
    }
  }
})

const onInput = object(listener, {
  type: input,
  passive,
  task: async (
    input
  ) => {
    const { form, name, value, ownerDocument } = input
    const target = name.slice(0, -9)// on supprime "_day_text"
    const targetFieldDate = one(`input[name='${target}_day']`, form)
    const minField = one(`input[name='${target}_min_day']`, form)
    const min = minField ? parseInt(minField.value) : null
    const maxField = one(`input[name='${target}_max_day']`, form)
    const max = maxField ? parseInt(maxField.value) : null
    const metaDateFormat = one(`meta[name="ea_s_date"]`, ownerDocument)
    const [dateFormat] = metaDateFormat ? meta('s_date') : ['DMY']
    const pattern = patterns[dateFormat]
    const selectors = all(`.${helpers.dateSelector.elements.container}`, ownerDocument)
    let selector = null
    let dateGMT
    let dateDays

    input.value = wmInput.has(input) ? value.replace(pattern, addSlashes) : value

    if (wmInput.has(input)) {
      wmInput.delete(input)
    }

    if (targetFieldDate) {
      if (value.length === 10) {
        dateGMT = new Date(value + ' GMT+0000')

        if (dateFormat === 'DMY') {
          const [dateDay, dateMonth, dateYear] = value.split('/')

          dateGMT = new Date(dateYear + '/' + dateMonth + '/' + dateDay + ' GMT+0000')
        }

        dateDays = Math.floor(dateGMT.getTime() / 86400 / 1000)
        targetFieldDate.value = dateDays

        if (selectors.length > 0) {
          for (const selectorsItem of selectors) {
            const { dataset } = selectorsItem
            const { targetName } = dataset

            if (targetName === target) {
              selector = selectorsItem
              
              if ((isInteger(min) && dateDays >= min && isInteger(max) && dateDays <= max)
                || (isInteger(min) && dateDays >= min && !isInteger(max))
                || (!isInteger(min) && isInteger(max) && dateDays <= max)
                || (!isInteger(min) && !isInteger(max))) {
                selectorsItem.dataset.activeDay = dateDays.toString()
                selectorSet.setCurrentDay(selector, dateGMT)
                selectorSet.setDays(selector, dateGMT)
              }
            }
          }
        }
      } else {
        targetFieldDate.value = ''
      }
    }
  }
})

export default input => {
  onKeyDown.listen(input)
  onInput.listen(input)
}
